export default "__VITE_ASSET__ChFH95bl__"